import Auth from 'live/services/authorization'

export const canManageWells = (): boolean => Auth.Permission.isAdmin || Auth.Permission.MANAGE_WELLS
